import {FaBrush} from "react-icons/fa";
import React from "react";
import {ExtraCleaningFeeModel} from "./ExtraCleaningFeeModel";
import {createOrUpdateExtraCleaningFee, deleteExtraCleaningFee, getExtraCleaningFee} from "../service/JobService";
import {FaBucket} from "react-icons/fa6";
import {Button, Modal} from "react-bootstrap";


export const ExtraCleaningFee = (props) => {
    const {job} = props;
    const [show, setShow] = React.useState(false);
    const [message, setMessage] = React.useState("")
    const [showConfirmDelete, setShowConfirmDelete] = React.useState(false);

    const handleSave = (e, extraCleaningFeeData) => {
        e.stopPropagation()
        let payload = {
            ...job,
            description: extraCleaningFeeData.description,
            extra_price: extraCleaningFeeData.extra_price,
            extra_price_work_order: extraCleaningFeeData.extra_price_work_order,
            id: extraCleaningFeeData.id,
            image_ids: extraCleaningFeeData.images.map(image => image.id)
        }
        createOrUpdateExtraCleaningFee(payload).then(response => {
            if (response.status === 200) {
                console.log("ExtraCleaning Fee saved successfully")
                handleClose(e)
                job.has_extra_cleaning_fee = payload.extra_price > 0
            } else {
                response.json().then(data => {
                    setMessage(data.message)
                })
                console.log("ExtraCleaning Fee save failed")
            }
        })
    }

    const handleDelete = (e) => {
        setShowConfirmDelete(false)
        e.stopPropagation()
        deleteExtraCleaningFee(job.cos_job_id).then(response => {
            if (response.status === 200) {
                job.has_extra_cleaning_fee = false
                handleClose(e)
            } else {
                response.json().then(data => {
                    setMessage(data.message)
                })
            }
        })

    }

    const handleClose = (e) => {
        if (e) {
            e.stopPropagation()
        }
        setMessage("")
        setShow(false)
    }

    return (
        <>
            <FaBucket
                style={{marginLeft: "10px", cursor: "pointer", color: job.has_extra_cleaning_fee ? "red" : "grey"}}
                size={22}
                title={"Extra Cleaning Fee"}
                onClick={(e) => {
                    e.stopPropagation()
                    setShow(true)
                }}
            /> {show &&
            <ExtraCleaningFeeModel
                show={show}
                job={job}
                handleSave={handleSave}
                handleClose={handleClose}
                handleDelete={() => setShowConfirmDelete(true)}
                message={message}
                setMessage={setMessage}
            />}
            <Modal show={showConfirmDelete} onHide={() => setShowConfirmDelete(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete the extra cleaning fee?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowConfirmDelete(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleDelete}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
